function isOnlyDigits(s: string): boolean {
  return s.length > 0 && [...s].every((ch) => ch >= "0" && ch <= "9");
}

export function formatCardDetailsExpirationMmYy(
  expirationMonth: number,
  expirationYear: number,
): string {
  const monthPart = String(expirationMonth).padStart(2, "0");
  const twoDigitYear = expirationYear % 100;
  const yearPart = String(twoDigitYear).padStart(2, "0");
  return `${monthPart}/${yearPart}`;
}

export function parseCardDetailsExpirationFromDb(
  value: string | null | undefined,
): { month: number; year: number } | null {
  if (value == null || value === "") {
    return null;
  }

  const slashSeparated = value.trim().split("/");
  if (slashSeparated.length !== 2) {
    return null;
  }

  const monthStr = slashSeparated[0];
  const yearStr = slashSeparated[1];

  if (monthStr === undefined || yearStr === undefined) {
    return null;
  }

  if (monthStr.length !== 2) {
    return null;
  }

  if (yearStr.length !== 2 && yearStr.length !== 4) {
    return null;
  }

  if (!isOnlyDigits(monthStr)) {
    return null;
  }
  if (!isOnlyDigits(yearStr)) {
    return null;
  }

  const month = Number.parseInt(monthStr, 10);
  if (!Number.isFinite(month)) {
    return null;
  }
  if (month < 1 || month > 12) {
    return null;
  }

  if (yearStr.length === 4) {
    const fullYear = Number.parseInt(yearStr, 10);
    if (!Number.isFinite(fullYear)) {
      return null;
    }
    return { month, year: fullYear };
  }

  const twoDigitYear = Number.parseInt(yearStr, 10);
  if (!Number.isFinite(twoDigitYear)) {
    return null;
  }
  if (twoDigitYear < 0 || twoDigitYear > 99) {
    return null;
  }
  const century = Math.floor(new Date().getFullYear() / 100) * 100;
  return { month, year: century + twoDigitYear };
}

// Is expiry date between:
//   today (inclusive)
//   AND
//   one month from today (inclusive)?
export function isCardExpiryEndWithinNextMonthWindow(
  expiryMonth: number,
  expiryYear: number,
): boolean {
  // 1. Get the last day of the expiry month
  const startOfLastDayOfExpiryMonth = new Date(expiryYear, expiryMonth, 0);

  // 2. Get start of today
  const startOfTodayLocal = new Date();
  startOfTodayLocal.setHours(0, 0, 0, 0);

  // 3. Get start of the day one month after today
  const startOfTodayPlusOneMonthLocal = new Date(startOfTodayLocal);
  startOfTodayPlusOneMonthLocal.setMonth(
    startOfTodayPlusOneMonthLocal.getMonth() + 1,
  );

  // 4. Convert everything to milliseconds
  const expiryMs = startOfLastDayOfExpiryMonth.getTime();
  const windowLowMs = startOfTodayLocal.getTime();
  const windowHighMs = startOfTodayPlusOneMonthLocal.getTime();

  // 5. Check if expiry is inside the window
  return expiryMs >= windowLowMs && expiryMs <= windowHighMs;
}
